export const imageWidth = 9643;
export const imageHeight = 10293;
export const bounds = [
  [0, 0],
  [imageHeight, imageWidth],
];